import * as React from 'react';

import { Box } from '@mui/material';

import styled from '@emotion/styled';

type BorderBoxProps = {
  title: string;
};

const BorderBox: React.FC<React.PropsWithChildren<BorderBoxProps>> = ({ children, title }) => (
  <Box
    sx={{
      height: '100%',
      backgroundColor: '#FCFCFC',
      border: '1px solid #f1f2f1',
      borderRadius: '14px',
      p: 3,
    }}
  >
    <Title>{title}</Title>
    {children}
  </Box>
);

export default BorderBox;

const Title = styled.h4`
  margin: 0 0 15px 0;
  color: #111;
  font-weight: 700;
  font-family: Poppins;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;
